/* eslint-disable max-lines */
import { css } from 'linaria';

export const swiperPreview = css`
  && {
    width: max-content;

    @media (--from-desktop) {
      padding-left: 22px;
      margin-right: 0;
      margin-left: 0;
    }

    @media (--to-desktop) {
      && {
        padding: 0;
        margin: 0;
      }
    }

    @media (--only-mobile) {
      && {
        width: 100%;
        padding-right: 16px;
        padding-left: 16px;
        margin-bottom: 24px;
      }
    }
  }
`;

export const swiperSlide = css`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    margin-right: 4px;
    cursor: pointer;

    @media (--from-desktop) {
      &:hover {
        border: 2px solid var(--control-primary);
        border-radius: 2px;
      }
    }

    &:last-of-type {
      margin-right: 0;
    }
    @media (--to-desktop) {
      margin-right: 8px;
    }
  }
`;

export const imagePreview = css`
  width: 32px;
  height: 32px;
  margin-right: 4px;
  cursor: pointer;

  &:last-of-type {
    margin-right: 0;
  }

  @media (--to-desktop) {
    margin-right: 8px;
  }
`;

export const activeImagePreview = css`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
  background: unset;
  border: 2px solid var(--control-primary);
  border-radius: 2px;
  opacity: unset;
`;

export const modalStyles = css`
  &&& {
    max-width: 100%;
    height: calc(100vh - 32px);
    margin: 16px 0;
    border-radius: var(--rounding-l);
    user-select: none;

    @media (--to-desktop) {
      width: 100vw;
      max-width: 100vw;
      min-height: 100vh;

      /* mobile viewport bug fix */
      height: fill-available;
      margin: 0 -16px;
      border-radius: 0;
    }
  }
`;

export const modalContent = css`
  height: 100%;
  padding: 48px;

  @media (--to-desktop) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0;
  }
`;

export const imageWrapper = css`
  position: relative;
  width: max-content;
  height: 100%;
  margin: 0 auto;

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const modalImageContainer = css`
  height: calc(100% - 80px);
  margin-bottom: 32px;

  @media (--only-tablet) {
    height: 100%;
    max-height: 482px;
    padding: 0;
    margin: auto 0;
  }

  @media (--only-mobile) {
    height: 37vh;
    padding: 0;
    margin: auto 0;
  }

  .swiper-button-prev {
    background-color: var(--control-minor);
    border: unset;

    &:hover {
      background-color: var(--control-hover-minor);
      border: unset;
    }
  }

  .swiper-button-next {
    background-color: var(--control-minor);
    border: unset;

    &:hover {
      background-color: var(--control-hover-minor);
      border: unset;
    }
  }
`;

export const swiperImage = css`
  height: 100%;

  @media (--from-desktop) {
    margin: 0 80px;
  }

  && {
    .swiper-button-next {
      right: 0;
    }

    .swiper-button-prev {
      left: 0;
    }
  }
`;

export const modalImage = css`
  display: block;
  height: 100%;
  margin: 0 auto;
  object-fit: contain;

  @media (--from-desktop) {
    width: calc((100vh - 32px - 96px - 48px - 32px) * 1.57);
  }

  @media (--to-desktop) {
    width: 100%;
    height: auto;
  }

  @media (--only-mobile) {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const modalFooter = css`
  display: flex;
  justify-content: space-between;
  column-gap: 20px;

  @media (--only-tablet) {
    margin-right: 16px;
    margin-bottom: 48px;
    margin-left: 16px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    margin-right: 0;
    margin-bottom: 24px;
    margin-left: 0;
  }
`;

export const footerButton = css`
  display: flex;
  align-items: center;

  @media (--only-mobile) {
    margin-right: 16px;
    margin-left: 16px;
  }
`;
